export enum Roles {
  Admin = 'Admin',
  Guest = 'Guest',
  Host = 'Host',
  Administrator = 'Administrator',
}

export interface PropertyListing {
  id: number;
  title: string;
  description: string;
  keyWords: string;
  pricePerNight: number;
  maxGuests: number;
  maxBed: number;
  maxBath: number;
  propertyCategory: string;
  isAvailable: boolean;
  ownerId: number;
  locationId: number;
  propertyStatus: string;
  phoneNumber: string;
  thumbnail: string;
  bedRoomImage: string;
  latitude: number;
  longitude: number;
  isLuxury: boolean;
  petsAllowed: number;
  smokingAllowed: boolean;
  partiesAllowed: boolean;
  roomType: string;
  childrenAllowed: number;
  wheelchairAccess: boolean;
  securityCameras: boolean;
  location: PropertyLocation;
  propertyPicture: PropertyPicture[];
  amenityDetails: AmenityDetail[];
}

export interface PropertyLocation {
  city: string;
  country: string;
  zipCode: number;
  address: string;
}

export interface PropertyPicture {
  path: string;
}

export interface AmenityDetail {
  amenityId: number;
}

export interface Amenity {
  amenityId: number;
  name: string;
  amenityType: string;
  iconPath: string;
}
export interface PropertyType {
  id: number;
  name: string;
}

export enum PropertyImageType {
  Thumbnail = 1,
  Bedroom = 2,
  PropertyImage = 3,
  Blog = 4,
}

export interface Pagination {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export interface PropertyStatusData {
  propertyId: number;
  propertyStatus: 'Approved' | 'Rejected' | 'Pending';
  rejectReason?: string;
}
export interface Users {
  fullName: string;
  firstName: string;
  middleName: string | null;
  lastName: string | null;
  email: string;
  gender: string | null;
  phoneNumber: string | null;
  profileImageUrl: string | null;
  dateOfBirth: string | null; // ISO date string
  placeOfResidence: string | null;
  zipCode: string | null;
  street: string | null;
  fbLink: string | null;
  instaLink: string | null;
  xLink: string | null;
  createdOn: string; // ISO date-time
  roleId: number;
  roles: string;
  id: string | null;
}

export interface ISearchRequest {
  PageNumber: number;
  PageSize: number;
  SortColumn: string;
  SortOrder: string;
  Search: string;
}

export interface AutocompletePrediction {
  displayName: string;
  description: string;
}

export interface Bookings extends ISearchRequest {
  BookingStatus: string;
}

export type BookingStatus = 'Pending' | 'Confirmed' | 'Cancelled';

export interface BookingDetails {
  id: number;
  checkInDate: string;
  checkOutDate: string;
  numberOfGuests: number;
  pricePerNight: number;
  totalPrice: number;
  discount: number;
  discountType: string | null;
  serviceFee: number;
  cleaningFee: number;
  totalPriceAfterTax: number;
  bookingStatus: BookingStatus;
  guestId: number;
  propertyProfileId: number;
  paymentId: number | null;
  propertyProfileName: string;
  propertyPicture: string;
  propertyAddress: string | null;
  overAllReviews: number;
  country: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;

  customerImg: string | null;
  guestEmail: string;
  guestPhone: string | null;
  guestName: string;

  hostId: number;
  hostFirstName: string;
  hostLastName: string;
  hostEmail: string;
  hostPhoneNumber: string | null;
}

export interface ToggleAvailability {
  propertyId: number;
  isAvailable: boolean;
}

// Moved from wishlist/actions.ts: Action type constants and WishlistItem interface
export enum ActionTypes {
  GET_GUEST_WISHLIST = '[Wishlist] Get Guest Wishlist',
  GET_GUEST_WISHLIST_SUCCESS = '[Wishlist] Get Guest Wishlist Success',
  GET_GUEST_WISHLIST_FAILURE = '[Wishlist] Get Guest Wishlist Failure',
  ADD_GUEST_WISHLIST_ITEM = '[Wishlist] Add Guest Wishlist Item',
  ADD_GUEST_WISHLIST_ITEM_SUCCESS = '[Wishlist] Add Guest Wishlist Item Success',
  ADD_GUEST_WISHLIST_ITEM_FAILURE = '[Wishlist] Add Guest Wishlist Item Failure',
  REMOVE_GUEST_WISHLIST_ITEM = '[Wishlist] Remove Guest Wishlist Item',
  REMOVE_GUEST_WISHLIST_ITEM_SUCCESS = '[Wishlist] Remove Guest Wishlist Item Success',
  REMOVE_GUEST_WISHLIST_ITEM_FAILURE = '[Wishlist] Remove Guest Wishlist Item Failure',

  GET_HOST_WISHLIST = '[Wishlist] Get Host Wishlist',
  GET_HOST_WISHLIST_SUCCESS = '[Wishlist] Get Host Wishlist Success',
  GET_HOST_WISHLIST_FAILURE = '[Wishlist] Get Host Wishlist Failure',
  ADD_HOST_WISHLIST_ITEM = '[Wishlist] Add Host Wishlist Item',
  ADD_HOST_WISHLIST_ITEM_SUCCESS = '[Wishlist] Add Host Wishlist Item Success',
  ADD_HOST_WISHLIST_ITEM_FAILURE = '[Wishlist] Add Host Wishlist Item Failure',
  REMOVE_HOST_WISHLIST_ITEM = '[Wishlist] Remove Host Wishlist Item',
  REMOVE_HOST_WISHLIST_ITEM_SUCCESS = '[Wishlist] Remove Host Wishlist Item Success',
  REMOVE_HOST_WISHLIST_ITEM_FAILURE = '[Wishlist] Remove Host Wishlist Item Failure',
}

// Moved from wishlist/actions.ts
export interface WishlistItem {
  id: number;
  propertyId: number;
  title?: string;
  city?: string;
  country?: string;
  thumbnail?: string;
  pricePerNight?: number;
  images?: string[];
}
